// LINTA — Theme JS

(function() {
  'use strict';

  /* ── Cart state ── */
  let cartData = { items: [], total_price: 0 };

  function formatMoney(cents) {
    return (cents / 100).toFixed(2).replace('.', ',') + ' kr';
  }

  async function fetchCart() {
    const res = await fetch('/cart.js');
    cartData = await res.json();
    return cartData;
  }

  async function addToCart(variantId, quantity) {
    const res = await fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: variantId, quantity: quantity })
    });
    if (!res.ok) throw new Error('Could not add to cart');
    await fetchCart();
    renderCartDrawer();
    openCartDrawer();
    showFlash('Added to bag');
    updateCartCount();
  }

  async function removeFromCart(key) {
    await fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: key, quantity: 0 })
    });
    await fetchCart();
    renderCartDrawer();
    updateCartCount();
  }

  function updateCartCount() {
    const count = cartData.item_count || 0;
    document.querySelectorAll('.cart-count').forEach(el => {
      el.textContent = count > 0 ? '(' + count + ')' : '';
    });
  }

  function renderCartDrawer() {
    const list = document.getElementById('cart-items-list');
    const emptyMsg = document.getElementById('cart-empty-msg');
    const footer = document.getElementById('cart-drawer-footer');
    const totalEl = document.getElementById('cart-total-price');
    if (!list) return;

    if (!cartData.items || cartData.items.length === 0) {
      list.innerHTML = '';
      if (emptyMsg) emptyMsg.style.display = 'block';
      if (footer) footer.style.display = 'none';
      return;
    }

    if (emptyMsg) emptyMsg.style.display = 'none';
    if (footer) footer.style.display = 'block';
    if (totalEl) totalEl.textContent = formatMoney(cartData.total_price);

    list.innerHTML = cartData.items.map(item => `
      <div class="cart-drawer-item">
        <div class="cart-drawer-item__img">
          ${item.image ? `<img src="${item.image}" alt="${item.product_title}" loading="lazy">` : ''}
        </div>
        <div class="cart-drawer-item__info">
          <div class="cart-drawer-item__name">${item.product_title}</div>
          <div class="cart-drawer-item__variant">${item.variant_title !== 'Default Title' ? item.variant_title : ''}</div>
          <div class="cart-drawer-item__price">${formatMoney(item.final_line_price)} · Qty ${item.quantity}</div>
          <button class="cart-drawer-item__remove" data-key="${item.key}">Remove</button>
        </div>
      </div>
    `).join('');

    list.querySelectorAll('[data-key]').forEach(btn => {
      btn.addEventListener('click', () => removeFromCart(btn.dataset.key));
    });
  }

  /* ── Cart drawer open/close ── */
  function openCartDrawer() {
    const drawer = document.getElementById('cart-drawer');
    if (!drawer) return;
    drawer.setAttribute('aria-hidden', 'false');
    document.body.style.overflow = 'hidden';
  }

  function closeCartDrawer() {
    const drawer = document.getElementById('cart-drawer');
    if (!drawer) return;
    drawer.setAttribute('aria-hidden', 'true');
    document.body.style.overflow = '';
  }

  /* ── Flash message ── */
  let flashTimer;
  function showFlash(msg) {
    let flash = document.querySelector('.flash');
    if (!flash) {
      flash = document.createElement('div');
      flash.className = 'flash';
      document.body.appendChild(flash);
    }
    flash.textContent = msg;
    flash.classList.add('show');
    clearTimeout(flashTimer);
    flashTimer = setTimeout(() => flash.classList.remove('show'), 2800);
  }

  /* ── Accordion ── */
  function initAccordions() {
    document.querySelectorAll('.accordion__trigger').forEach(trigger => {
      trigger.addEventListener('click', function() {
        const body = this.nextElementSibling;
        const isOpen = this.classList.contains('open');
        this.classList.toggle('open', !isOpen);
        body.classList.toggle('open', !isOpen);
      });
    });
  }

  /* ── Product page variant selection ── */
  function initProductPage() {
    const form = document.getElementById('product-form');
    if (!form) return;

    const variantInput = form.querySelector('[name="id"]');
    const priceEl = document.getElementById('product-price');
    const atcBtn = document.getElementById('atc-btn');
    const qtyInput = document.getElementById('qty-input');

    // Variant option buttons
    const optionGroups = form.querySelectorAll('.variant-group');

    function getSelectedOptions() {
      const opts = [];
      optionGroups.forEach(group => {
        const active = group.querySelector('.variant-option.active');
        if (active) opts.push(active.dataset.value);
      });
      return opts;
    }

    function findVariant(selectedOpts) {
      const variants = JSON.parse(form.dataset.variants || '[]');
      return variants.find(v => {
        const vOpts = [v.option1, v.option2, v.option3].filter(Boolean);
        return selectedOpts.every((opt, i) => vOpts[i] === opt);
      });
    }

    function updateVariant() {
      const selected = getSelectedOptions();
      const variant = findVariant(selected);
      if (variant) {
        variantInput.value = variant.id;
        if (priceEl) priceEl.textContent = formatMoney(variant.price * 100 / 100) + ' kr';
        if (atcBtn) {
          atcBtn.disabled = !variant.available;
          atcBtn.textContent = variant.available ? 'Add to Bag' : 'Sold Out';
        }
      }
    }

    optionGroups.forEach(group => {
      group.querySelectorAll('.variant-option').forEach(btn => {
        btn.addEventListener('click', function() {
          group.querySelectorAll('.variant-option').forEach(b => b.classList.remove('active'));
          this.classList.add('active');
          updateVariant();
        });
      });
    });

    // Qty stepper
    document.getElementById('qty-minus')?.addEventListener('click', () => {
      if (qtyInput && parseInt(qtyInput.value) > 1) qtyInput.value = parseInt(qtyInput.value) - 1;
    });
    document.getElementById('qty-plus')?.addEventListener('click', () => {
      if (qtyInput) qtyInput.value = parseInt(qtyInput.value) + 1;
    });

    // ATC
    atcBtn?.addEventListener('click', async function(e) {
      e.preventDefault();
      const id = variantInput.value;
      const qty = parseInt(qtyInput?.value || '1');
      if (!id) return;
      this.disabled = true;
      this.textContent = 'Adding...';
      try {
        await addToCart(id, qty);
      } catch (err) {
        showFlash('Could not add to bag');
      }
      this.disabled = false;
      this.textContent = 'Add to Bag';
    });

    // Gallery thumbs
    document.querySelectorAll('.product-gallery__thumb').forEach((thumb, i) => {
      thumb.addEventListener('click', function() {
        document.querySelectorAll('.product-gallery__thumb').forEach(t => t.classList.remove('active'));
        this.classList.add('active');
        const mainImg = document.querySelector('.product-gallery__main img');
        if (mainImg) mainImg.src = this.dataset.src;
      });
    });
  }

  /* ── Mobile nav ── */
  function initMobileNav() {
    const toggle = document.querySelector('.nav-toggle');
    const mobileNav = document.getElementById('mobile-nav');
    if (!toggle || !mobileNav) return;
    toggle.addEventListener('click', () => {
      const open = mobileNav.classList.toggle('open');
      toggle.setAttribute('aria-expanded', open);
    });
  }

  /* ── Init ── */
  document.addEventListener('DOMContentLoaded', async function() {
    // Cart drawer events
    document.querySelectorAll('[data-cart-open]').forEach(el => {
      el.addEventListener('click', async () => {
        await fetchCart();
        renderCartDrawer();
        openCartDrawer();
      });
    });
    document.querySelector('.cart-drawer__close')?.addEventListener('click', closeCartDrawer);
    document.querySelector('.cart-drawer__overlay')?.addEventListener('click', closeCartDrawer);

    // Init modules
    initAccordions();
    initProductPage();
    initMobileNav();

    // Fetch initial cart count
    try {
      await fetchCart();
      updateCartCount();
    } catch(e) {}
  });

})();
